(function ($, Cobalt, undefined) {
    Cobalt.UserContentManager =
    {
        dependentScripts: function () { return [{ dependency: Cobalt.CMS, name: "Cobalt.CMS"}] },
        initialize: function () {

            if ($.browser.msie) {
                window.onbeforeunload = null; //short circuit message about leaving page when submitting form; remove if fixed in IE
            }

            $(".j-user-content-list").on("change", "input.j-content-item-checkbox", function (e) {
                var checkbox = $(this);
                var wrapper = checkbox.parents("div.wrapper");

                if (checkbox.is(":checked")) {
                    wrapper.addClass("selected");
                } else {
                    wrapper.removeClass("selected");
                }
            });

            $(".j-display-style-toggle").on("click", "a", function (e) {
                var displayStyle = $(this).attr("data-display-style");
                $.cookie("Cobalt.UserContentManager.DisplayStyle", displayStyle, { 'expires': 365 });
                self.location.reload();
            });

            $("#field-preview").click(function (e) {
                e.preventDefault();
                var $postForm = $("form#post-form");
                var categoryID = $postForm.attr("data-category-id");
                var postID = $postForm.attr("data-post-id");
                if (postID > 0) {
                    $postForm.attr("action", "/my-content/" + categoryID + "/posts/" + postID + "/preview");
                } else {
                    $postForm.attr("action", "/my-content/" + categoryID + "/posts/preview");
                }
                $postForm.attr("target", "preview");
                $postForm.submit();
                $postForm.attr("action", "");
                $postForm.attr("target", "");
            });

            $("body").on("change", "#field-parent-category", function () {
                var selectedOption = $(this).find("option[value='" + $(this).val() + "']");
                var titleField = $("#form-field-title");
                if (selectedOption.length > 0 && titleField.length > 0) {
                    if (selectedOption.attr("data-naming-enabled") === "True") {
                        titleField.show();
                    } else {
                        titleField.hide();
                    }
                }
            });

            $("body").on("click", "a.j-cancel-button", function (e) {
                //$.log($(this));
                $(this).parents("div.ui-dialog-content").dialog("close");
            });

            Cobalt.TinyMCE.optionsOverridden = true;

            var customPlugins = "imageborder,postexcerpt,postpagebreak,postwidget,spoiler,tabgroupaddtab,videoembed,xenonmedia";
            var toolBarConfig = "paste bold italic underline strikethrough blockquote | formatselect alignleft aligncenter alignright | fontselect fontsizeselect forecolor | searchreplace | fullscreen"
                + " | bullist numlist | hr removeformat | outdent indent spoiler | link unlink | image | imageborder | videoembed | postpagebreak";

            if (Cobalt.PostWidget.showPostWidgets) {
                customPlugins += ",postwidget";
                toolBarConfig += " postwidget";
            }

            Cobalt.TinyMCE.options = {
                skin_url: Cobalt.TinyMCE.skin_url,
                setup: function (ed) {
                    ed.on("init", function (evt) {
                        var editor = evt.target;

                        Cobalt.TinyMCE._enableBlockQuoteBreakout(editor);

                        $("#" + editor.id + "_blockquote").on("click", function () {
                            editor.dom.add(editor.getBody(), 'p', null, '<br />');
                        });

                        Cobalt.TinyMCE.tinyMCELoaded(editor);
                    });
                },
                formats: {
                    bold: { inline: 'strong' },
                    italic: { inline: 'em' },
                    strikethrough: { inline: 'del' },
                    address: { inline: 'addr' },
                    removeformat: [
                    {
                        selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del',
                        remove: 'all',
                        split: true,
                        expand: false,
                        block_expand: true,
                        deep: true
                    },
                    { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
                    { selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true }
                    ]
                },
                end_container_on_empty_block: true,
                body_class: "text u-typography-format",
                content_css: Cobalt.CMS.getTinyMCECss(),
                selector: "#field-body-wysiwyg",
                menubar: false,
                width: "100%",
                height: "400px",
                plugins: "colorpicker,fullscreen,hr,image,link,media,noneditable,paste,searchreplace,table,textcolor",
                external_plugins: Cobalt.TinyMCE._addExtraCustomPlugins(customPlugins),
                dialog_type: "modal",
                toolbar: toolBarConfig,
                extended_valid_elements: "article[id|class],header,aside[class],div[*],tab[*],iframe[allowfullscreen|src|height|width]",
                custom_elements: 'tab',
                block_formats: "Paragraph=p;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6;Pre=pre;",
                relative_urls: false,
                paste_auto_cleanup_on_paste: true,
                paste_remove_styles: true,
                paste_remove_styles_if_webkit: true,
                paste_strip_class_attributes: "all",
                gecko_spellcheck: true,
                paste_text_sticky: true,
                forced_root_block: "p",
                heading_clear_tag: "p",
                schema: "html5",
                remove_script_host: false,
                media_live_embeds: false
            };

            Cobalt.runOnHtmlInsert(function ($parent) {
                //$.log("Looking for form in:");
                //$.log($parent);
                var form = $parent.find("form.j-modal-form");
                if (form.length == 0) {
                    return;
                }
                //$.log("Processing form: ");
                //$.log(form);
                if (form.data("_initialized") != null) {
                    //$.log("Form already initialized");
                    return;
                }

                //$.log("Initializing form");

                form.data("_initialized", true);

                form.ajaxForm(
                {
                    type: 'post',
                    cache: false,
                    beforeSubmit: function (data) {
                        form.find(".j-cancel-button").hide();
                        form.find(".j-submit-button").addClass("disabled");
                        form.find(".j-form-saving").show();
                    },
                    success: function (data) {
                        if (!data.Successful) {
                            var html = $(data.html);
                            var formHtml = html.find("form").html();
                            //$.log("Replacing form with: " + formHtml);
                            form.html(formHtml);
                            //$.log("Triggering html insert...");
                            Cobalt.triggerHtmlInsert(form);
                        } else {
                            if (data.Url != null) {
                                self.location.href = data.Url;
                            } else {
                                self.location.reload();
                            }

                        }
                    }
                });
            });

            Cobalt.UserContentManager.initializeRevisionSystem();
        },
        initializeRevisionSystem: function () {

            // NOTE: For this to work, it needs to be refactored to include the csrf token
            $("div.j-revision-selector").on("click", "a.j-revision", function (e) {
                var revisionNumber = $(this).attr("data-revision");
                var postID = $(this).attr("data-post-id");
                if (!confirm("Are you sure you want to restore the content of this post to an earlier revision (Revision " + revisionNumber + ")? You will lose any unsaved changes to your post.")) {
                    return;
                }

                var revisionContent = $.ajax(
                {
                    type: "POST",
                    url: Cobalt.Routes.Instance.UserContentPostRestoreRevision(postID, revisionNumber),
                    dataType: "json",
                    success: function (result) {
                        $("#field-body-wysiwyg").val(result.Body);
                        $("#field-body").val(result.Body);
                    }
                });
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.UserContentManager.js